import React, { useState , useMemo} from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook que obtiene los query params de la url actual, retorna una instancia de la clase URLSearchParams. 
 */
export const useQueryParams = ()=>{
    const {search} = useLocation();
    return useMemo(()=> new URLSearchParams(search), [search])
}